import TrashieContainer from './TrashieContainer';

export default TrashieContainer;
